export default {
  index: [
    {
      path: '/commodity',
      component: resolve => require(['./commodityIndex.vue'], resolve),
    }
  ]
}



// WEBPACK FOOTER //
// ./src/view/commodity/_router.js